<template>
	<FileUpload name="files" :multiple="false" type="file" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" :maxFileSize="10000000" 
		@upload="onAdvancedUpload($event)" @select="onSelectedFiles" class="border-300">
		<template #header="{ chooseCallback, uploadCallback, clearCallback, files }">
			<div class="flex flex-wrap justify-content-between align-items-center flex-1">
				<div class="flex flex-row gap-2 w-full">
					<Button @click="chooseCallback()" 
						:disabled="files.length >= maxFiles || loading"
						severity="info"
						:label="content[lang_].btn_attach" icon="pi pi-plus" iconPos="right"
						class="flex flex-1 border-none text-sm font-medium border-round-lg" />

					<Button @click="uploadEvent(uploadCallback, clearCallback)" 
						:disabled="!files || files.length === 0 || files.length > maxFiles || loading"
						:label="content[lang_].btn_send" icon="pi pi-cloud-upload" iconPos="right"
						class="flex flex-1 border-none text-sm font-medium border-round-lg" />
					
					<Button @click="clearCallback()" class="flex"
						icon="pi pi-times" rounded outlined severity="danger" v-if="files && files.length>0" />
				</div>
			</div>
		</template>
		<template #content="{ loaded, uploaded, removeUploadedFileCallback, removeFileCallback }">

			<div v-if="files.length > 0" class="w-full surface-0 p-3">
				<span class="flex text-600 text-md mb-2 font-medium">{{ content[lang_].to_send }}</span>
				<div class="flex flex-column p-0 gap-3">
					<div v-for="(file, index) of files" :key="file.name + file.type + file.size" 
						class="w-full m-0 p-2 flex flex-row border-1 surface-border align-items-left gap-2 border-round-lg">
						<div class="flex relative" style="width:50px;height:50px">
							<div class="absolute w-full h-full top-0 left-0 right-1 bottom-0 overflow-hidden border-1 border-round-lg surface-border align-items-center justify-content-center">
								<img v-if="file.objectURL" role="presentation" :alt="file.name" :src="file.objectURL" 
									class="w-full absolute" style="object-fit:cover;object-position:center;min-height:100%;min-width:100%" />
								<i v-else class="absolute pi pi-file flex text-lg text-500" style="top:-10px;left:-10px;margin-top:25px;margin-left:25px"/>
							</div>
						</div>
						<div class="flex flex-1 flex-column text-600">
							<span class="flex text-sm font-medium mb-1">{{ getShortName(file.name) }}</span>
							<span class="flex text-xs mb-1">{{ formatSize(file.size) }}</span>
							<span v-if="!loading" class="flex text-xs mb-1 text-orange-600">{{ content[lang_].didnt_sent }}</span>
							<span v-if="loading" class="flex text-xs mb-1 text-primary">{{ content[lang_].sending }}</span>
						</div>
						<div>
							<Button icon="pi pi-times" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded  severity="danger" />
						</div>
					</div>
				</div>
			</div>

			<div v-if="uploadedFiles.length > 0" class="w-full surface-0 p-3">
				<span v-if="!loading" class="flex text-600 text-md mb-2 font-medium">{{ content[lang_].sent }}</span>
				<span v-if="loading" class="flex text-600 text-md mb-2 font-medium">{{ content[lang_].sending }}</span>
				<div class="flex flex-column p-0 gap-3">
					<div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size" 
						class="w-full m-0 p-2 flex flex-row border-1 surface-border align-items-left gap-2 border-round-lg">
						<div class="flex relative" style="width:50px;height:50px">
							<div class="absolute w-full h-full top-0 left-0 right-1 bottom-0 overflow-hidden border-1 border-round-lg surface-border align-items-left">
								<img v-if="file.objectURL" role="presentation" :alt="file.name" :src="file.objectURL" 
									class="w-full absolute" style="object-fit:cover;object-position:center;min-height:100%;min-width:100%" />
								<i v-else class="absolute pi pi-file flex text-lg text-500" style="top:-10px;left:-10px;margin-top:25px;margin-left:25px"/>
							</div>
						</div>
						<div class="flex flex-1 flex-column text-600">
							<span class="flex text-sm font-medium mb-1">{{ getShortName(file.name) }}</span>
							<span class="flex text-xs mb-1">{{ formatSize(file.size) }}</span>
							<span v-if="!loading" class="flex text-xs mb-1 text-green-600">{{ content[lang_].sent }}</span>
							<span v-if="loading" class="flex text-xs mb-1 text-primary">{{ content[lang_].sending }}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #empty>
			<div class="flex align-items-center justify-content-center flex-column"></div>
		</template>
	</FileUpload>
</template>

<script>
import Connect from "@/assets/js/Connect";

export default {
	name: "uploadFiles",
	props: ['data', 'multiple', 'maxFiles', 'uploadUrl'],
	data() {
		return {
			files: [],
			uploadedFiles: [],
			loading: false,
            totalSize: 0,
            totalSizePercent: 0,
			content: {
                ru: {
					success: 'Успешно',
					error: 'Ошибка',
					file_uploaded: 'Файл загружен',
					maximum_files: 'Максимальное количество файлов 3',
					btn_attach: 'Прикрепить',
					btn_send: 'Загрузить',
					to_send: 'К отправке',
					didnt_sent: 'Не отправлено',
					sending: 'Отправляется',
					sent: 'Отправлено',
				},
				en: {
					success: 'Success',
					error: 'Error',
					file_uploaded: 'File uploaded',
					maximum_files: 'Maximum files 3',
					btn_attach: 'Attach',
					btn_send: 'Upload',
					to_send: 'To send',
					didnt_sent: 'Not sent',
					sending: 'Sending',
					sent: 'Sent',
				}
			},
		}
	},
	setup() {},
	methods: {
		getShortName(name) {
			return name.length > 10 ? name.slice(0, 3) + '...' + name.slice(-7) : name
		},
        clearCallback() {
            this.onClearTemplatingUpload(this.$refs.fileUpload.clear);
        },
		onRemoveTemplatingFile(file, removeFileCallback, index) {
            removeFileCallback(index);
            this.totalSize -= parseInt(this.formatSize(file.size));
            this.totalSizePercent = this.totalSize / 10;
        },
        onClearTemplatingUpload(clear) {
            clear();
            this.totalSize = 0;
            this.totalSizePercent = 0;
            this.$emit('onReset', true)
        },
        onSelectedFiles(event) {
            this.files = event.files;
            this.files.forEach((file) => {
                this.totalSize += parseInt(this.formatSize(file.size));
            });
        },
        async uploadEvent(callback, clear) {
            this.totalSizePercent = this.totalSize / 10;
			
			await this.onAdvancedUpload().then(res => {
				this.totalSize = 0;
				this.totalSizePercent = 0;	
				callback();
			})
			clear()
        },
        onTemplatedUpload() {
            this.$toast.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 });
        },
		formatSize(bytes) {
            const k = 1024;
            const dm = 3;
            const sizes = this.$primevue.config.locale.fileSizeTypes;

            if (bytes === 0) {
                return `0 ${sizes[0]}`;
            }

            const i = Math.floor(Math.log(bytes) / Math.log(k));
            const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

            return `${formattedSize} ${sizes[i]}`;
        },
		showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
		async onAdvancedUpload(event) {
			// в случае с отправкой формы
			if(event) return

			this.$emit('onLoading', true)
			this.loading = true


			const files = this.files
			if (files.length <= 0) {
				this.$emit('onLoading', false)
				this.loading = false
				return
			}
			if (files.length > this.maxFiles) {
				this.showMess('error', 'Ошибка', 'Максимальное количество файлов'+ this.maxFiles)
				this.files = []
				this.$emit('onLoading', false)
				this.loading = false
				return
			}
			let formData = new FormData()

			for (let i = 0; i < files.length; i++) {
				formData.append("files", files[i])
			}

			// добавить к formdata еще данные
			if(this.data){
				for (const [key, value] of Object.entries(this.data)) {
					formData.append(key, value)
				}
			}

			const upload = await this.connect.sendFiles(formData, this.uploadUrl).then(res => res)
			if (upload.result && upload.data) {
				this.uploadedFiles = [...this.uploadedFiles, ...this.files]
				this.files = []
				this.showMess('success', "Успешно", "Файлы загружены")
				this.$emit('onLoading', false)
				this.loading = false
				this.$emit('onUpload', upload.data)
				return
			} else {
				if(upload.errors && upload.errors.length > 0 ){
					for (let i = 0; i < upload.errors.length; i++) {
						this.showMess('error', 'Ошибка', upload.errors[i])
						this.$emit('onLoading', false)
						this.loading = false
						return
					}
				}
			}

		}
	},
	computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
	beforeCreate() {
		this.connect = new Connect();
	},
	mounted() {}
}
</script>
